import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'font-awesome/css/font-awesome.min.css';


function ProjectDetailMap({
  project,
  zoom = 8,
  height = 400,
  iconMarker = 'ship',
  color = '#2a81cb',
}) {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!project || mapRef.current) return;
    const { latitude, longitude } = project;
    if (latitude == null || longitude == null) return;

    const map = L.map('project-map', {
      center: [latitude, longitude],
      zoom,
      zoomControl: false,
    });

    map.scrollWheelZoom.disable();
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.tap && map.tap.disable();

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; OpenStreetMap',
    }).addTo(map);

    const html = `
    <div class="custom-marker" style="color: ${color}">
      <svg width="24" height="36" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 0C5.4 0 0 5.4 0 12c0 7.2 6 15.6 12 24 6-8.4 12-16.8 12-24C24 5.4 18.6 0 12 0z" fill="currentColor"/>
      </svg>
      <i class="fa fa-${iconMarker} marker-icon"></i>
    </div>
  `;

    const icon = L.divIcon({
      className: '',
      html,
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -12],
    });

    const marker = L.marker([latitude, longitude], { icon }).addTo(map);

    if (project.name || project.description) {
      const safeName = project.name ? `<strong>${project.name}</strong><br/>` : '';
      const safeDesc = project.description || '';
      marker.bindPopup(`${safeName}${safeDesc}`);
    }
    mapRef.current = map;

    return () => {
      map.remove();
      mapRef.current = null;
    };
  }, [project, zoom, iconMarker, color]);

  return (
    <div
      id="project-map"
      style={{ width: '100%', height }}
      tabIndex={0}
      aria-label={project?.name || 'Project location map'}
    />
  );
}

export default ProjectDetailMap;